import { array, intersect, literal, partial, string, struct, union } from 'io-ts/lib/Decoder';

import { Category } from '../../../notification/Category';

export const Request = intersect(
	struct({
		category: Category,
	})
)(
	partial({
		type: union(literal('announcement'), literal('chat'), literal('other')),
		notificationIds: array(string),
	})
);
